import React, { useState } from "react";
import { useSnackbar } from "notistack";
import { RemoveContractRecordDialog, EditRecordDialog } from "@icoach/nonMember/dialog";
import useNonMember from "@icoach/nonMember/components/useNonMember";
import { Icons, Typography, IconButton, Card, Divider, Stack, Box } from "@curves/ui-base";
import useAjax from "@apis/useAjax";
import { parseDate } from "@util/moment";

const ProspectContactRecordBox = props => {
	const { contactDate, contactResultTypeText, coachName, contactID, customerID, title, notes } = props;
	const [isOpen, setOpen] = useState(null);
	const { enqueueSnackbar: _snackbar } = useSnackbar();
	const { refresh } = useNonMember();
	const Ajax = useAjax();

	const removeApi = async (_customerID, _contactID) => {
		const resp = await Ajax.delete(`/api/customers/${_customerID}/contact-records/${_contactID}`);
		if (resp) {
			_snackbar("成功刪除聯繫紀錄", { variant: "success" });
			refresh && refresh.current && refresh.current();
		} else {
			_snackbar("失敗", { variant: "error" });
		}
	};

	const editApi = async (_customerID, _contactID, par) => {
		const resp = await Ajax.put(`/api/customers/${_customerID}/contact-records/${_contactID}`, par);
		if (resp) {
			_snackbar("成功刪除聯繫紀錄", { variant: "success" });
			setOpen(null);
			refresh && refresh.current && refresh.current();
		} else {
			_snackbar("失敗", { variant: "error" });
		}
	};

	return (
		<React.Fragment>
			<Card isOverflowHidden className="contact-record-card">
				<Card.CardContent>
					<Stack justifyContent="space-between" className="pt-2 px-2">
						<Box component="span" className="nonmember-info-contact-markbook">
							<Typography variant="h5" className="nonmember-info-contact-date">
								{parseDate(contactDate)}
							</Typography>
						</Box>
						<Box>
							<IconButton onClick={() => setOpen("edit")}>
								<Icons.Edit />
							</IconButton>
							<IconButton onClick={() => setOpen("remove")}>
								<Icons.Trash />
							</IconButton>
						</Box>
					</Stack>
					<Stack justifyContent="space-between" className="px-3 py-3">
						<Box className="overflow-hidden">
							<Box component="span" className="nonmember-info-contact-label">
								狀態
							</Box>
							<Box component="span" className="nonmember-info-contact-label-text">
								{contactResultTypeText}
							</Box>
						</Box>
						<Box className="overflow-hidden">
							<Box component="span" className="nonmember-info-contact-label">
								擔當
							</Box>
							<Box component="span" className="nonmember-info-contact-label-text">
								{coachName}
							</Box>
						</Box>
					</Stack>
				</Card.CardContent>
				<Divider />
				<Card.CardContent>
					<Box className="px-3 py-2">
						<Typography variant="h6" className="title py-2">
							{title}
						</Typography>
						<Typography className="content pb-4">{notes}</Typography>
					</Box>
				</Card.CardContent>
			</Card>
			<RemoveContractRecordDialog open={isOpen === "remove"} onClose={() => setOpen(null)} refresh={() => removeApi(customerID, contactID)} />
			<EditRecordDialog open={isOpen === "edit"} setOpen={() => setOpen(null)} doAction={_par => editApi(customerID, contactID, _par)} title={title} notes={notes} />
		</React.Fragment>
	);
};

export default ProspectContactRecordBox;
